import { useTranslation } from 'react-i18next';
import { useStore } from '../../store/store';
import { NavbarListButton } from '../Layout/NavbarListButton';
import { FONT_SIZES } from '../../constants/constants';

const selector = ({ configuration }) => ({
  configuration,
});

const FontFamilyButton = ({
  active,
  label,
  onToggle,
  fontFamily,
  positionStyle,
  size = '32px'
}) => {
  return (
    <div
      onClick={() => onToggle(fontFamily)}
      style={{
        width: '80px',
        height: '80px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        border: active ? '2px solid #1890ff' : '1px solid #d9d9d9',
        borderRadius: '4px',
        backgroundColor: active ? '#e6f7ff' : 'white',
        fontSize: '12px',
        fontFamily: fontFamily,
        fontWeight: active ? 'bold' : 'normal',
        padding: '4px',
        textAlign: 'center',
        ...positionStyle,
      }}
      title={label}
    >
      {label}
    </div>
  );
};

const FontFamilyControl = (props) => {
  const { configuration } = useStore(selector);
  var currentStyle = props?.editorState?.getCurrentInlineStyle();

  // Police rendue sans police propre à la sélection : celle du style de texte,
  // à défaut celle du document.
  let selectedFontFamily = props.fontFamily || configuration.fontFamily;
  configuration?.fontFamilyList.forEach((type) => {
    if (currentStyle?.includes(`FONT_FAMILY_${type.key}`)) {
      selectedFontFamily = type.familyName;
    }
  });

  const { t } = useTranslation();

  // Créer les options de famille de police
  const fontFamilyOptions = configuration?.fontFamilyList || [];

  return (
    <NavbarListButton
      title={t('font-family')}
      disabled={false}
      icon={
        <span style={{
          fontSize: '12px',
          fontFamily: selectedFontFamily,
          width: '100%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }}>
          {selectedFontFamily}
        </span>
      }
      onListElementClick={props.applyFontFamily}
      isOpen={props.isOpen}
      onToggleOpen={props.onToggleOpen}
      customStyle={{
        borderRadius: 0,
        width: props.width ?? 120,
        margin: 0,
      }}
    >
      {fontFamilyOptions.map((option, index) => (
        <FontFamilyButton
          key={option.key}
          active={option.familyName === selectedFontFamily}
          label={option.familyName}
          onToggle={props.applyFontFamily}
          fontFamily={option.familyName}
          positionStyle={{
            gridColumn: Math.ceil((index + 1) / 2),
            gridRow: (index % 2) + 1,
          }}
          size='80px'
        />
      ))}
    </NavbarListButton>
  );
};

export default FontFamilyControl;
